export default __webpack_public_path__ + "static/media/alternative_metal_band.ced1487a.webp";